// extracted by mini-css-extract-plugin
export default {"termination-page-container":"termination-page_termination-page-container__0vC0e","terminationPageContainer":"termination-page_termination-page-container__0vC0e"};